import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class PaymentPurchaseApplyApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'paymentPurchaseApply'
  }

}